import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from '../services/api.js';

const initialState = {
  loading: true,
  error: '',
  rows: [],
  headers: [],
  grandTotals: { total: 0 },
};

const buildHeaders = (data) => {
  const allStatuses = new Set();
  data.forEach((row) => {
    (row.statuses || []).forEach((status) => allStatuses.add(status.status));
  });
  return Array.from(allStatuses).sort();
};

const buildGrandTotals = (data, headers) => {
  const totals = {};
  let totalOfTotals = 0;

  headers.forEach((header) => {
    let headerTotal = 0;
    data.forEach((row) => {
      const status = (row.statuses || []).find((s) => s.status === header);
      if (status) {
        headerTotal += status.count;
      }
    });
    totals[header] = headerTotal;
  });

  data.forEach((row) => {
    totalOfTotals += row.totalCount || 0;
  });
  totals['Grand Total'] = totalOfTotals;

  return totals;
};

export const fetchSummary = createAsyncThunk(
  'summary/fetchSummary',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get('/records/summary');
      return response.data || [];
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        'Failed to load summary data.';
      return rejectWithValue({ message });
    }
  }
);

const summarySlice = createSlice({
  name: 'summary',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSummary.pending, (state) => {
        state.loading = true;
        state.error = '';
      })
      .addCase(fetchSummary.fulfilled, (state, action) => {
        const data = Array.isArray(action.payload) ? action.payload : [];
        const headers = buildHeaders(data);
        state.rows = data;
        state.headers = headers;
        state.grandTotals = buildGrandTotals(data, headers);
        state.loading = false;
        state.error = '';
      })
      .addCase(fetchSummary.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || 'Failed to load summary data.';
      });
  },
});

export const selectSummary = (state) => state.summary;

export default summarySlice.reducer;
